<template>
  <div class="ThreeColumnRow">
    <div class="title" v-if="isShowTitle">
        <span>{{dataTitle}}</span>
        <span  v-show="hasMore===1" class="more" @click="toMore">更多<img src="@/assets/icon_jump.png"></span>
    </div>
    <div class="list">
        <div class="item" v-for="(item, key) in list" :key="key" @click="clickOpen(item)">
            <div class="header">
                <img :src="item.icon">
                <!-- <div class="playback">
                    <img v-if="item.type == 1" src="@/assets/icon_play.png">
                    <img v-else src="@/assets/icon_listen.png">
                    <span>{{item.playback}}次播放</span>
                </div> -->
            </div>
            <div class="title">{{item.title}}</div>
        </div>
        <div class="item filling"></div>
        <div class="item filling"></div>
        <div class="item filling"></div>
    </div>
  </div>
</template>

<script>
import { cblockItem } from '@/api/app'

export default {
  name: 'ThreeColumnRow',
  props: {
    isShowTitle: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Number,
      default: 1
    },
    dataId: {
      default: null
    },
    dataTitle: {
      type: String,
      default: null
    },
    list: {
      type: Array,
      default: () =>{
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
      toMore: function(item){
        this.$emit('clickMore', this.dataId, this.dataTitle);
      },
      clickOpen: function(item){
        cblockItem(item, this)
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ThreeColumnRow {
  padding: 8px 16px;
  color: #333;
}
.ThreeColumnRow > .title{
  display: flex;
  justify-content:space-between;
  font-size: 19px;
  font-weight: 600;
  padding: 13px 0;
}
.ThreeColumnRow .title .more{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 100;
    color: #AAA;
}
.ThreeColumnRow .title img{
    width: 16px;
}
.ThreeColumnRow .list{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.ThreeColumnRow .list .item{
  width: 28vw;
  background-color: #fff;
  padding: 0 3px;
  padding-bottom: 6px;
  border-radius: 6px;
  margin-bottom: 10px;
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.06);
}
.ThreeColumnRow .list .item .header{
    position: relative;
}
.ThreeColumnRow .list .item .header > img{
    width: 100%;
    display: inherit;
    border-radius: 6px;
}
.ThreeColumnRow .list .item .header .playback{
    width: 100%;
    text-align: left;
    background-color: rgba(0,0,0,0.5);
    position: absolute;
    bottom: 0;
    padding: 5px 0;
    color: #fff;
    font-size: 10px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    display: flex;
    align-items: center;
}
.ThreeColumnRow .list .item .header .playback img{
    width: 13px;
    margin: 0 5px;
}
.ThreeColumnRow .list .item .title{
    font-size: 13px;
    text-align: left;
    font-weight: 600;
    margin: 5px 0 0 0;
    color: #333333;
}
.ThreeColumnRow .list .item.filling{
  padding: 0;
  border-radius: 0;
  margin: 0px;
  box-shadow: none;
  background-color: transparent;
}
</style>
